import { Record, Map, List } from 'immutable'

import { USA_CODE, USA_ISO } from 'app/constants/phoneCountryCodes'

export const OrganizationSettingsRecord = Record({
  id: null,
  name: null,
  domain: null,
  logo: null,
  totalUsers: null,
  welcomeEmail: Map(),
})

export class OrganizationSettings extends OrganizationSettingsRecord {}

export class CountriesCodesForSelect extends Record({
  country: USA_ISO,
  code: USA_CODE,
}) {}

export class OrganizationSettingsByDomain extends Record({
  sms: false,
  promoPageSettings: {
    isPromoPageActive: false,
    image: undefined,
    title: undefined,
    subTitle: undefined,
  },
  organizationId: null,
  language: null,
  countriesCodes: List(),
}) {}

export class PromoPage extends Record({
  isPromoPageActive: false,
  image: undefined,
  title: undefined,
  subTitle: undefined,
}) {}
